import axios from "axios";
import React from "react";
import { useNavigate } from "react-router-dom";
const NavAdmin = ({ admin,setError }) => {

  const LinkTO = useNavigate();
  async function LogoutAdmin() {
    try {
      console.log("Clicked")
      const response = await axios.get(
        "http://localhost:5000/api/admin/logout",
        {
          withCredentials: true, // ✅ send cookies automatically
        }
      );
      if(response.status === 200){
        LinkTO("/admin/login")
      }
      console.log(response);
    }
    catch (err) {
      console.log(err);
      setError({ message: "Error While Logout Contact Developer", type: "error" })
    }
  }
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm px-4 fixed-top">
      <div className="container-fluid">
        {/* Left Side */}
        <span className="navbar-brand mb-0 h1">{admin}</span>

        {/* Right Side */}
        <div className="d-flex">
          <button className="btn btn-outline-danger" onClick={() => LogoutAdmin()}>
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default NavAdmin;
